import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

export const LIBRARY_TEMPLATE_SEARCH_PARAM = 'q'

export function useLibraryTemplateSearch() {
  const [searchParams, setSearchParams] = useSearchParams()
  const search = searchParams.get(LIBRARY_TEMPLATE_SEARCH_PARAM) ?? ''

  const setSearch = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev)
          const trimmed = value.trim()
          if (trimmed) {
            next.set(LIBRARY_TEMPLATE_SEARCH_PARAM, value)
          } else {
            next.delete(LIBRARY_TEMPLATE_SEARCH_PARAM)
          }
          return next
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { search, setSearch }
}
